import { cn } from "../../../../lib/utils";

interface ReportLayoutHeader {
  title: string;
  rootContainerClassName?: string;
  childContainerClassName?: string;
  titleClassName?: string;
  actions?: React.ReactNode;
}

const ReportHeader: React.FC<ReportLayoutHeader> = ({
  title,
  rootContainerClassName,
  childContainerClassName,
  titleClassName,
  actions
}) => {
  return (
    <div className={cn("bg-gray-50 rounded-t-xl mt-2", rootContainerClassName)}>
      <div className={cn("w-full h-[52px] px-2.5 py-1.5 flex items-center justify-between", childContainerClassName)}>
        <span className={cn("truncate text-[#0A0A0A] font-sans text-lg font-medium leading-7", titleClassName)}>
          {title}
        </span>

        {actions && (
          <div className="flex items-center gap-2">
            {actions}
          </div>
        )}

        {/* Actions will be uncomment when came into use */}
        {/* <div className="flex items-center gap-3">
          <ButtonV2
            variant="outline-primary"
            size="md"
            prefix={<CheckCheck className="h-4 w-4" />}
          >
            Status
          </ButtonV2>

          <ButtonV2
            variant="outline-primary"
            size="md"
            prefix={<Mail className="h-4 w-4" />}
          >
            Send Email
          </ButtonV2>

          <ButtonV2
            variant="outline-primary"
            size="md"
            prefix={<Download className="h-4 w-4" />}
          >
            Download
          </ButtonV2> */}
      </div>
    </div>
  );
};

export default ReportHeader;
